import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { snakeCase } from 'lodash';
import { getImage } from 'gatsby-plugin-image';
import { DonateBanner as DonateBannerComponent } from '@comicrelief/component-library';
import { donateOrientationMapping, paddingOptionMapping } from '../../utils/optionMapping';
import { handleScroll } from '../ImpactSlider/_utils';
import { changeTextColor } from '../RichText/utils';

const getPictureProps = (asset) => {
  if (!asset) return null;

  return {
    image: asset?.images?.fallback?.src || null,
    images: asset?.images?.sources?.[0]?.srcSet
      || asset?.images?.fallback?.srcSet
      || null,
    imageLow: asset?.placeholder?.fallback || null,
    alt: asset?.description || ''
  };
};

const DonateBanner = ({
  donateBanner = {
    cartId: 'default-comicrelief',
    clientId: 'donate',
    donationUrl: '/donate'
  },
  moneyBuys = []
}) => {
  const moneyBuy = donateBanner.cartId && moneyBuys.filter(
    e => e.node.cartId === donateBanner.cartId
  );

  const hasMoneyBuy = moneyBuy.length > 0;

  const mbshipID = `mbship-${donateBanner.id || donateBanner.contentful_id || 'donate-banner'}`;

  const lImageData = getImage(donateBanner?.lImage);
  const mImageData = getImage(donateBanner?.mImage);
  const sImageData = getImage(donateBanner?.sImage);

  const imageL = getPictureProps(lImageData);
  const imageM = getPictureProps(mImageData);
  const imageS = getPictureProps(sImageData);

  const mediumPosterData = donateBanner?.mImage?.posterImageData;
  const largePosterData = donateBanner?.lImage?.posterImageData;

  const mediumPosterUrl = mediumPosterData?.images?.fallback?.src
    ?? mImageData?.images?.fallback?.src ?? donateBanner?.mImage?.file?.url;

  const largePosterUrl = largePosterData?.images?.fallback?.src
    ?? lImageData?.images?.fallback?.src ?? donateBanner?.lImage?.file?.url;

  const videoDesktop = donateBanner?.lVideo?.file?.url;
  const videoMobile = donateBanner?.smVideo?.file?.url;
  const videoLoopProp = donateBanner.loopAmbientVideo ?? true;

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const urlParams = new URLSearchParams(window.location.search);
    handleScroll(urlParams);
  }, []);

  return (
    hasMoneyBuy
    && (
      <DonateBannerComponent
        donateWidgetIsTextOnly={donateBanner.donateWidgetIsTextOnly || false}
        donateOrientation={donateOrientationMapping[donateBanner.donateOrientation]}
        paddingAbove={donateBanner.paddingAbove
          ? paddingOptionMapping[donateBanner.paddingAbove] : undefined}
        paddingBelow={donateBanner.paddingBelow
          ? paddingOptionMapping[donateBanner.paddingBelow] : undefined}
        pageBackgroundColour={
          donateBanner.pageBackgroundColour
            ? snakeCase(donateBanner.pageBackgroundColour)
            : 'white'
        }
        componentBackgroundColour={
          donateBanner.componentBackgroundColour
            ? snakeCase(donateBanner.componentBackgroundColour)
            : 'white'
        }
        copyColor={donateBanner.donateWidgetIsTextOnly
          ? changeTextColor(snakeCase(donateBanner.componentBackgroundColour)) : undefined}
        title={donateBanner.title || ''}
        subtitle={donateBanner.subtitle || ''}
        monthlyTitle={donateBanner.monthlyTitle || ''}
        monthlySubtitle={donateBanner.monthlySubtitle || ''}
        popUpText={donateBanner.popUpText}
        otherAmountText={donateBanner.otherAmountText || undefined}
        monthlyOtherAmountText={donateBanner.monthlyOtherAmountText || ''}
        hideMoneyBuys={donateBanner.hideMoneyBuys || false}
        imageL={imageL}
        imageM={imageM}
        imageS={imageS}
        videoDesktop={videoDesktop}
        videoMobile={videoMobile}
        posterDesktop={largePosterUrl}
        posterMobile={mediumPosterUrl}
        videoLoop={videoLoopProp}
        data={moneyBuy[0].node}
        cartID={moneyBuy[0].node.cartId}
        clientID={donateBanner.clientId || 'donate'}
        donateLink={donateBanner.donationUrl || '/donate'}
        mbshipID={mbshipID}
      />
    )
  );
};

DonateBanner.propTypes = {
  donateBanner: PropTypes.objectOf(PropTypes.shape),
  moneyBuys: PropTypes.arrayOf(PropTypes.shape)
};

export default DonateBanner;
